// extracted by mini-css-extract-plugin
module.exports = {"container":"CauseModal_container__3pXfj","curt":"CauseModal_curt__1qvqG","explains":"CauseModal_explains__26OHS"};